import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';

import PageTitle from '@/shared/components/layouts/PageTitle';
import { AppPath } from '@/shared/constants/path';

const Title: FC = () => {
  const { t } = useTranslation(['payments', 'common']);

  return (
    <PageTitle
      title={t('payments:payments')}
      breadcrumbs={[
        {
          label: t('payments:payments'),
          icon: (
            <PaymentOutlinedIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
          to: AppPath.Payments,
        },
      ]}
    />
  );
};

export default Title;
